import HouseDesignForm from "../component/HouseDesignForm";

const HouseDesignEdit = () => {
  return <HouseDesignForm isEditMode={true} />;
};

export default HouseDesignEdit;
